import {
  // faBell,
  faBook,
  faCloudUploadAlt,
  faCalendar,
  faVideo,
  faDatabase,
  faHomeUser,
  faUserCheck,
  faUser,
  faSheetPlastic,
  faStoreAlt,
  faNewspaper,
  faDownload,
  faBookBookmark,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import {
  dashboardUrls,
  downloadableMaterial,
  liveClassUrls,
  studentUrls,
  materialUrls,
  newsUrls,
  blogUrls,
  one2OneTutoring,
  practiceHubUrls,
  roleUrls,
  staticPagesUrls,
  testUrls,
  userUrls,
  chapterUrls,
  simulatorUrls,
  // subChapterUrls,
} from "../Api/Auth/AppUrls";
import { faDochub } from "@fortawesome/free-brands-svg-icons";
export const sidebarDataAdmin = [
  { to: dashboardUrls.admin, icon: faHomeUser, label: "Dashboard" },
  {
    to: downloadableMaterial.adminFreeModelTest,
    icon: faCloudUploadAlt,
    label: "Downloadable Materials",
  },
  // {
  //   to: "/paid-tests",
  //   icon: faFolderOpen,
  //   label: "Paid Model Tests",
  // },
  {
    to: downloadableMaterial.adminSubscriptionMaterials,
    icon: faBook,
    label: "FE Subscription Materials",
  },
  // {
  //   to: "/notifications",
  //   icon: faBell,
  //   label: "Notifications",
  //   hasNotification: true,
  // },
  { to: one2OneTutoring.pageCivil, icon: faCalendar, label: "1 to 1 Tutoring" },
  { to: liveClassUrls.pageCivil, icon: faVideo, label: "Live Class" },
  {
    to: practiceHubUrls.pageCivil,
    icon: faDochub,
    label: "Practice Hub",
  },
  {
    to: simulatorUrls.pageCivil,
    icon: faPencil,
    label: "Simulator",
  },
  { to: materialUrls.list, icon: faBook, label: "Materials" },
  { to: testUrls.list, icon: faSheetPlastic, label: "Test" },
  { to: chapterUrls.pageCivil, icon: faBookBookmark, label: "Chapters" },
  { to: newsUrls.list, icon: faNewspaper, label: "News" },
  { to: blogUrls.list, icon: faNewspaper, label: "Blogs" },
  { to: null, icon: faDatabase, label: "Storage" },
  { to: staticPagesUrls.home, icon: faStoreAlt, label: "Static Pages" },
  { to: roleUrls.list, icon: faUserCheck, label: "User Role" },
  { to: userUrls.list, icon: faUser, label: "User" },
];
export const sidebarDataStudent = [
  { to: dashboardUrls.student, icon: faHomeUser, label: "Dashboard" },
  // {
  //   to: "/student-courses",
  //   icon: faUser,
  //   label: "Student Courses",
  // },

  { to: studentUrls.liveClass, icon: faVideo, label: "Live Class" },
  {
    to: studentUrls.studentQuizBankCivil,
    icon: faBookBookmark,
    label: "Quiz Bank",
  },
  {
    to: studentUrls.studentSimulatorCivil,
    icon: faPencil,
    label: "Simulator",
  },
  {
    to: studentUrls.studentSubscriptionMaterials,
    icon: faBook,
    label: "Subscription Materials",
  },
  {
    to: studentUrls.studentPracticeHub,
    icon: faDochub,
    label: "Practice Hub",
  },
  {
    to: studentUrls.studentPaidModelTest,
    icon: faDownload,
    label: "Paid Model Test",
  },
  {
    to: studentUrls.studentTutoring,
    icon: faCalendar,
    label: "1 to 1 Tutoring",
  },
];

export const freeMaterialsTabsData = [
  // { label: "Free FE Quiz", path: downloadableMaterial.adminFreeFeQuiz },
  {
    label: "Free FE Model Test(Civil)",
    path: downloadableMaterial.adminFreeModelTest,
  },
  {
    label: "Free FE Model Test(Mechanical)",
    path: downloadableMaterial.adminMechanicalFreeModelTest,
  },
  {
    label: "Free FE Material(Civil)",
    path: downloadableMaterial.adminFreeMaterial,
  },
  {
    label: "Free FE Material(Mechanical)",
    path: downloadableMaterial.adminMechanicalFreeMaterial,
  },
  {
    label: "Paid Model Test(Civil)",
    path: downloadableMaterial.adminPaidModelTest,
  },
  {
    label: "Paid Model Test(Mechanical)",
    path: downloadableMaterial.adminMechanicalPaidModelTest,
  },
];

export const staticPagesTabsData = [
  { label: "Home", path: staticPagesUrls.home },
  { label: "Single Pages", path: staticPagesUrls.singlePage },
  { label: "Contact Us", path: staticPagesUrls.contact },
  { label: "Privacy Policies", path: staticPagesUrls.privacyPolicy },
  { label: "Terms of Services", path: staticPagesUrls.termsOfService },
  { label: "Footer Pages", path: staticPagesUrls.footer },
];
export const tutoringPagesTabsData = [
  { label: "Page(Civil)", path: one2OneTutoring.pageCivil },
  { label: "Page(Mechanical)", path: one2OneTutoring.pageMechanical },
  { label: "Packages", path: one2OneTutoring.packages },
  { label: "Tutoring Purchase", path: one2OneTutoring.purchase },
];
export const practiceHubTabsData = [
  { label: "Page(Civil)", path: practiceHubUrls.pageCivil },
  { label: "Page(Mechanical)", path: practiceHubUrls.pageMechanical },
  { label: "Topics", path: practiceHubUrls.adminTopic },
  { label: "Sub Topics", path: practiceHubUrls.adminSubTopicTopic },
];
export const chapterTabsData = [
  { label: "Quiz Bank(Civil)", path: chapterUrls.pageCivil },
  { label: "Quiz Bank(Mechanical)", path: chapterUrls.pageMechanical },
  { label: "Chapters", path: chapterUrls.list },
];
export const simulatorTabsData = [
  { label: "Simulator(Civil)", path: simulatorUrls.pageCivil },
  { label: "Simulator(Mechanical)", path: simulatorUrls.pageMechanical },
  { label: "Model Tests", path: simulatorUrls.list },
  { label: "Free Model Test Users", path: simulatorUrls.freeModelTestTakers },
];
export const simulatorQuestionTabsData = [
  { label: "Model Test Questions", path: simulatorUrls.questions },
];
export const subChapterTabsData = [{ label: "Sub Chapters", path: "#" }];
export const subChapterQuestionTabsData = [{ label: "Questions", path: "#" }];
export const liveClassTabsData = [
  { label: "Page(Civil)", path: liveClassUrls.pageCivil },
  { label: "Page(Mechanical)", path: liveClassUrls.pageMechanical },
  { label: "Live Classes", path: liveClassUrls.liveClasses },
];
export const materialSubscriptionTabsData = [
  {
    label: "Page(Civil)",
    path: downloadableMaterial.adminSubscriptionMaterials,
  },
  {
    label: "Page(Mechanical)",
    path: downloadableMaterial.adminMechanicalSubscriptionMaterials,
  },
];

export const studentPracticeHubTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentPracticeHub,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentPracticeHubMechanical,
  },
];
export const studentQuizBankTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentQuizBankCivil,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentQuizBankMechanical,
  },
];
export const studentLiveClassTabsData = [
  {
    label: "Civil",
    path: studentUrls.liveClass,
  },
  {
    label: "Mechanical",
    path: studentUrls.liveClassMechanical,
  },
];
export const studentSubscriptionMaterialTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentSubscriptionMaterials,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentSubscriptionMaterialsMechanical,
  },
];
export const studentPaidModelTestTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentPaidModelTest,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentPaidModelTestMechanical,
  },
];
export const studentTutoringTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentTutoring,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentTutoringMechanical,
  },
];
export const studentSimulatorTabsData = [
  {
    label: "Civil",
    path: studentUrls.studentSimulatorCivil,
  },
  {
    label: "Mechanical",
    path: studentUrls.studentSimulatorMechanical,
  },
];
